import { render } from "./mercadopagoForm.vue?vue&type=template&id=02a9beda&scoped=true&ts=true"
import script from "./mercadopagoForm.vue?vue&type=script&lang=ts"
export * from "./mercadopagoForm.vue?vue&type=script&lang=ts"

import "./mercadopagoForm.vue?vue&type=style&index=0&id=02a9beda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a9beda"]])

export default __exports__